import React from "react";
import { CameraOff } from "lucide-react";

// Three distinct dead ends, each with a different next step — collapsing them
// into one generic message either tells the candidate to do something useless
// (rescanning a QR that's already claimed elsewhere fails the same way again)
// or, worse, tells someone whose *other* device is fine to go regenerate and
// kill that live pairing.
const COPY = {
  invalid: {
    heading: "Access Denied",
    body: "This QR code isn't valid. Check the link, or ask for the current one on your laptop screen.",
  },
  expired: {
    heading: "Can't Reconnect",
    body: "This QR code is no longer active, so rescanning it won't help. On your laptop, tap “Regenerate QR” (or “Show new QR code”) to get a fresh one, then scan that instead.",
  },
  claimed: {
    heading: "Already Connected",
    body: "This QR code is already linked to another device, which may already be monitoring fine. If that's your other phone, you're all set, so close this tab. If not, get a new QR code from your laptop.",
  },
};

const AccessDeniedScreen = ({ variant = "invalid" }) => {
  const { heading, body } = COPY[variant] || COPY.invalid;
  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-4">
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 text-center max-w-sm border border-gray-700/50">
        <div className="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <CameraOff className="w-6 h-6 text-red-400" />
        </div>
        <h2 className="text-lg font-semibold text-white mb-2">{heading}</h2>
        <p className="text-gray-300 text-sm">{body}</p>
      </div>
    </div>
  );
};

export default AccessDeniedScreen;
